//#region header */
/**************************************************************************************************
//
//  Description: All the colour codes used in the application
//
//  Copyright:    © 2023 - 2024 Idox Software Limited.
//
//  Useful links:
//    https://g.co/kgs/mwa7VU
//    https://rgbacolorpicker.com/
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   06.10.23 Sean Flook                 Initial version.
//    002   09.02.24 Sean Flook                 Added new colours for ASD records.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */

export const adsWhite = "#FFFFFF"; // 36 files
export const adsOffWhite = "#F8F9FA"; // 8 files
export const adsLightGreyA = "#E1E1E1"; // 11 files
export const adsLightGreyB = "#D7D7D7"; // 16 files
export const adsLightGreyC = "#EEEFF0"; // 7 files
export const adsLightGreyD = "#AAAAAA"; // 3 files
export const adsLightGreyA50 = "#E1E1E180"; // 6 files
export const adsMidGreyA = "#535353"; // 33 files
export const adsMidGreyA10 = "#4242421A"; // 1 file
export const adsMidGreyA30 = "#4242424D"; // 1 file
export const adsMidGreyB = "#797979"; // 3 files
export const adsMidGreyC = "#8C8B8B"; // 1 file
export const adsDarkGrey = "#333333"; // 8 files
export const adsDarkGrey10 = "#3333331A"; // 2 files
export const adsDarkGrey20 = "#33333333"; // 2 files
export const adsBlack = "#000000"; // 10 files
export const adsBlack0 = "#00000000"; // 1 file
export const adsBlack125 = "#00000020"; // 1 file
export const adsBlack20 = "#00000033"; // 1 file
export const adsPaleBlueA = "#E6F3F9"; // 5 files
export const adsPaleBlueB = "#DFF1F9"; // 4 files
export const adsBlueA = "#2A6EBB"; // 65 files
export const adsBlueB = "#286EBB"; // 2 files
export const adsBlue12 = "#1976D21F"; // 3 files
export const adsLightBlue = "#00AEEF"; // 30 files
export const adsLightBlue10 = "#00AEEF1A"; // 17 files
export const adsMidBlueA = "#40A4D4"; // 6 files
export const adsMidBlueB = "#027DB4"; // 2 files
export const adsRoyalBlue = "#000080"; // 2 files
export const adsDarkBlue = "#323097"; // 6 files
export const adsRed = "#C4051C"; // 18 files
export const adsRed10 = "#C4051C1A"; // 7 files
export const adsRed20 = "#C4051C33"; // 6 files
export const adsMidRed = "#F01010"; // 5 files
export const adsDarkRed = "#8C0415"; // 2 files
export const adsMagenta = "#D900B6"; // 6 files
export const adsYellow = "#F6E20D"; // 8 files
export const adsGreenA = "#2ABB2E"; // 5 files
export const adsGreenB = "#03B615"; // 1 file
export const adsGreenC = "#23A127"; // 1 file
export const adsDarkGreen = "#0F7B40"; // 4 files
export const adsLightPurple = "#DD95DA"; // 4 files
export const adsPurple = "#A04AA9"; // 1 file
export const adsDarkPurple = "#3D329B";
export const adsLightPink = "#F78599"; // 4 files
export const adsPink = "#BB2A6E"; // 8 files
export const adsDarkPink = "#970d34"; // 4 files
export const adsLightBrown = "#996122"; // 5 files
export const adsMidBrownA = "#B8741A"; // 1 file
export const adsMidBrownB = "#AA4B1D"; // 1 file
export const adsBrown = "#8C510D"; // 6 files
export const adsOrange = "#F48910"; // 4 files
export const adsDarkOrange = "#DB5700";
